export default __webpack_public_path__ + "static/media/shark2.fb87eec6.png";